import { render } from "./CustomizedZone.vue?vue&type=template&id=7b053e8f&scoped=true"
import script from "./CustomizedZone.vue?vue&type=script&lang=js"
export * from "./CustomizedZone.vue?vue&type=script&lang=js"

import "./CustomizedZone.vue?vue&type=style&index=0&id=7b053e8f&lang=scss&scoped=true"
import "./CustomizedZone.vue?vue&type=style&index=1&id=7b053e8f&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b053e8f"]])

export default __exports__